import {useEffect, useState} from "react";
import charDetailBgMain from "../../assets/images/charactor/detail/char_detail_bg_main.png";
import charDetailBgMain2x from "../../assets/images/charactor/detail/char_detail_bg_main@2x.png";
import charBtnAudioDefault from "../../assets/images/charactor/detail/char_btn_audio_default.png";
import charBtnAudioActive from "../../assets/images/charactor/detail/char_btn_audio_active.png";
import commonBtnPlayDefault from "../../assets/images/charactor/detail/common_btn_play_default.png";
import commonBtnPlayActive from "../../assets/images/charactor/detail/common_btn_play_active.png";
import commonBtnBack from "../../assets/images/commonbtn/common_btn_back.png";
import commonBtnBack2x from "../../assets/images/commonbtn/common_btn_back@2x.png";
import commonBtnBackHover from "../../assets/images/commonbtn/common_btn_back_hover.png";
import commonBtnBackHover2x from "../../assets/images/commonbtn/common_btn_back_hover@2x.png";
import commonBtnPreviousDefault from "../../assets/images/commonbtn/common_btn_previous_default.png";
import commonBtnPreviousDefault2x from "../../assets/images/commonbtn/common_btn_previous_default@2x.png";
import commonBtnPreviousHover from "../../assets/images/commonbtn/common_btn_previous_hover.png";
import commonBtnPreviousHover2x from "../../assets/images/commonbtn/common_btn_previous_hover@2x.png";
import commonBtnNextDefault from "../../assets/images/commonbtn/common_btn_next_default.png";
import commonBtnNextDefault2x from "../../assets/images/commonbtn/common_btn_next_default@2x.png";
import commonBtnNextHover from "../../assets/images/commonbtn/common_btn_next_hover.png";
import commonBtnNextHover2x from "../../assets/images/commonbtn/common_btn_next_hover@2x.png";
import charDetailDeco1 from "../../assets/images/charactor/detail/char_detail_deco_1.png";
import charDetailDeco2 from "../../assets/images/charactor/detail/char_detail_deco_2.png";
import charDetailDeco3 from "../../assets/images/charactor/detail/char_detail_deco_3.png";
import charDetailDeco3_2x from "../../assets/images/charactor/detail/char_detail_deco_3@2x.png";

const ROLE_DETAIL_DESIGN_HEIGHT = 1080;

const getRoleDetailScale = function () {
    if (typeof window === "undefined") return 1;
    return Math.min(1, window.innerHeight / ROLE_DETAIL_DESIGN_HEIGHT);
};

export default function RoleDetailModal({
    isOpen,
    role,
    onClose,
    onPrev,
    onNext,
    onVoicePlay,
    onVideoPlay
}) {
    const [roleDetailScale, setRoleDetailScale] = useState(getRoleDetailScale);
    const voices = role && Array.isArray(role.voices) ? role.voices : [];
    const playableVoice = voices.find(function (voice) { return Boolean(voice.audioUrl); });
    const hasVideo = Boolean(role) && typeof onVideoPlay === "function";

    useEffect(() => {
        const handleResize = function () {
            setRoleDetailScale(getRoleDetailScale());
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!isOpen) return undefined;

        const handleKeyDown = function (event) {
            if (event.key === "Escape") {
                onClose();
                return;
            }
            if (event.key === "ArrowLeft") onPrev();
            if (event.key === "ArrowRight") onNext();
        };

        const preventPageWheel = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        const listenerOptions = {passive: false, capture: true};
        const previousBodyOverflow = document.body.style.overflow;
        const previousHtmlOverflow = document.documentElement.style.overflow;

        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("wheel", preventPageWheel, listenerOptions);
        window.addEventListener("touchmove", preventPageWheel, listenerOptions);

        return () => {
            document.body.style.overflow = previousBodyOverflow;
            document.documentElement.style.overflow = previousHtmlOverflow;
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("wheel", preventPageWheel, listenerOptions);
            window.removeEventListener("touchmove", preventPageWheel, listenerOptions);
        };
    }, [isOpen, onClose, onPrev, onNext]);

    if (!role) return null;

    const wideImg = role.detailWideImg || role.thumbnail || role.personImg;
    const wideImg2x = role.detailWideImg2x;
    const personImg = role.detailPersonImg || role.personImg;
    const personImg2x = role.detailPersonImg2x;
    const detailInfoTexts = Array.isArray(role.detailInfoTexts) ? role.detailInfoTexts : [];
    const detailTitleText = detailInfoTexts[0] || role.name;
    const quoteText = detailInfoTexts[1] || (Array.isArray(role.cardLines) ? role.cardLines.join("") : "");

    const handleVoiceClick = function () {
        if (playableVoice && typeof onVoicePlay === "function") onVoicePlay(playableVoice.audioUrl);
    };

    return (
        <div
            className={isOpen ? "role-detail-mask open" : "role-detail-mask"}
            aria-hidden={isOpen ? "false" : "true"}
            onWheel={(event) => {
                event.preventDefault();
                event.stopPropagation();
            }}
        >
            <picture className="role-detail-bg-picture">
                <source media="(min-width: 1921px)" srcSet={charDetailBgMain2x}/>
                <img className="role-detail-bg" src={charDetailBgMain} alt="" />
            </picture>
            <section
                className="role-detail-modal"
                role="dialog"
                aria-modal="true"
                aria-label={`${role.name}角色详情`}
                style={{"--role-detail-scale": roleDetailScale}}
            >
                <div className="role-detail-wide-stage" aria-hidden="true">
                    <picture>
                        {wideImg2x ? <source media="(min-width: 1921px)" srcSet={wideImg2x}/> : null}
                        <img className="role-detail-wide-art" src={wideImg} alt="" />
                    </picture>
                </div>
                <img className="role-detail-deco role-detail-deco-1" src={charDetailDeco1} alt="" aria-hidden="true" />
                {role.detailNameDeco ? (
                    <picture>
                        {role.detailNameDeco2x ? <source media="(min-width: 1921px)" srcSet={role.detailNameDeco2x}/> : null}
                        <img className="role-detail-name-deco" src={role.detailNameDeco} alt={role.englishName || role.name} />
                    </picture>
                ) : null}
                <img className="role-detail-deco role-detail-deco-2" src={charDetailDeco2} alt="" aria-hidden="true" />
                <picture>
                    <source media="(min-width: 1921px)" srcSet={charDetailDeco3_2x}/>
                    <img className="role-detail-deco role-detail-deco-3" src={charDetailDeco3} alt="" aria-hidden="true" />
                </picture>
                <div className="role-detail-info-panel">
                    <h2>{detailTitleText}</h2>
                    <button
                        className="role-detail-quote-btn"
                        type="button"
                        aria-label={playableVoice ? `播放${role.name}语音：${quoteText}` : `${role.name}语音：${quoteText}`}
                        aria-disabled={!playableVoice}
                        onClick={handleVoiceClick}
                    >
                        <img className="default" src={charBtnAudioDefault} alt="" aria-hidden="true" />
                        <img className="active" src={charBtnAudioActive} alt="" aria-hidden="true" />
                        {quoteText ? <span>{quoteText}</span> : null}
                    </button>
                </div>

                <aside className="role-detail-person-panel">
                    <picture>
                        {personImg2x ? <source media="(min-width: 1921px)" srcSet={personImg2x}/> : null}
                        <img className="role-detail-person-art" src={personImg} alt={`${role.name}角色立绘`} />
                    </picture>
                    <button
                        className="role-detail-play-btn role-detail-image-btn"
                        type="button"
                        hidden
                        aria-label={hasVideo ? `播放${role.name}角色视频` : "暂无角色视频"}
                        disabled={!hasVideo}
                        onClick={onVideoPlay}
                    >
                        <img className="default" src={commonBtnPlayDefault} alt="" aria-hidden="true" />
                        <img className="active" src={commonBtnPlayActive} alt="" aria-hidden="true" />
                    </button>
                </aside>

            </section>

            <div className="role-detail-actions">
                <button className="role-detail-home-btn role-detail-image-btn" type="button" aria-label="返回主页" onClick={onClose}>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnBack2x}/><img className="default" src={commonBtnBack} alt="" aria-hidden="true" /></picture>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnBackHover2x}/><img className="active" src={commonBtnBackHover} alt="" aria-hidden="true" /></picture>
                </button>
                <button className="role-detail-prev-btn role-detail-image-btn" type="button" aria-label="上一个角色" onClick={onPrev}>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnPreviousDefault2x}/><img className="default" src={commonBtnPreviousDefault} alt="" aria-hidden="true" /></picture>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnPreviousHover2x}/><img className="active" src={commonBtnPreviousHover} alt="" aria-hidden="true" /></picture>
                </button>
                <button className="role-detail-next-btn role-detail-image-btn" type="button" aria-label="下一个角色" onClick={onNext}>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnNextDefault2x}/><img className="default" src={commonBtnNextDefault} alt="" aria-hidden="true" /></picture>
                    <picture><source media="(min-width: 1921px)" srcSet={commonBtnNextHover2x}/><img className="active" src={commonBtnNextHover} alt="" aria-hidden="true" /></picture>
                </button>
            </div>
        </div>
    );
}
